Postlogin.Permissions = (function () {
    const init = function () {
        const grantUrl = $('#role-permissions').attr('data-grant-url');
        const revokeUrl = $('#role-permissions').attr('data-revoke-url');

        /*
         * Add or Remove a specific permission for a specific role
         */
        $('#role-permissions').on('change', '.checkbox input:checkbox', function () {
            const $checkbox = $(this);
            const roleId = $checkbox.attr('data-role-id');
            const permissionId = $checkbox.attr('data-permission-id');

            if ($checkbox.prop('checked')) {
                $(this).closest('li').addClass('checked');
                $.ajax({
                    url: grantUrl,
                    type: 'POST',
                    data: {
                        role_id: roleId,
                        permission_id: permissionId,
                        csrf_token: Jr.getCsrfToken(),
                    },
                    success() {},
                    error(data) {
                        $checkbox.closest('li').removeClass('checked');
                        $checkbox.prop('checked', false);
                        let errorMessage = '';
                        if (data.status < 400) {
                            errorMessage = 'You do not have access to perform this action.';
                        } else {
                            errorMessage = data.responseJSON.errors;
                        }
                        window.alert(errorMessage);
                    },
                });
            } else {
                $checkbox.closest('li').removeClass('checked');
                $.ajax({
                    url: revokeUrl,
                    type: 'POST',
                    data: {
                        role_id: roleId,
                        permission_id: permissionId,
                    },
                    success() {},
                    error(data) {
                        $checkbox.closest('li').addClass('checked');
                        $checkbox.prop('checked', true);
                        let errorMessage = '';
                        if (data.status < 400) {
                            errorMessage = 'You do not have access to perform this action.';
                        } else {
                            errorMessage = data.responseJSON.errors;
                        }
                        window.alert(errorMessage);
                    },
                });
            }
        });
    };

    return {
        init,
    };
}());
